module.exports = __webpack_public_path__ + "static/media/circle-notch.6a91c1d5.svg";